var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwimming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1371 22.5687L23.1762 21.02C24.1847 22.273 26.0507 22.3353 27.14 21.1769C28.1347 20.1192 28.0839 18.4581 27.0261 17.4633C25.9689 16.4689 24.3075 16.5193 23.3126 17.5772C22.5483 18.39 22.4096 19.5456 22.84 20.478L20.5156 16.7317L23.9649 15.7364C25.0361 15.4273 25.5423 14.2011 24.9981 13.2258C24.6029 12.5177 23.7827 12.1801 23.0036 12.405L17.7816 13.9118C16.4276 14.3026 15.8213 15.8765 16.5647 17.0748L18.1431 19.6186L15.375 21.3362C18.7052 21.4127 21.1114 22.4266 24.1371 22.5687Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7463 24.2935C18.3165 22.1416 21.1755 26.486 29.5619 24.2969C29.8751 24.2151 30.0626 23.895 29.9809 23.5819C29.8992 23.2689 29.579 23.0813 29.266 23.163C21.2088 25.2663 18.3458 20.915 10.4259 23.1663C10.1146 23.2548 9.934 23.5789 10.0225 23.8901C10.111 24.2015 10.4352 24.382 10.7463 24.2935Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.266 25.8988C21.194 28.0059 18.3615 23.6462 10.4259 25.9021C10.1146 25.9906 9.934 26.3146 10.0225 26.6259C10.111 26.9372 10.4351 27.1178 10.7463 27.0293C18.3165 24.8774 21.1755 29.2217 29.5619 27.0326C29.8751 26.9509 30.0626 26.6308 29.9809 26.3177C29.8992 26.0046 29.579 25.817 29.266 25.8988Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/swimming.d9adf2bfef41c3ea964d7748d2ff552e.svg";
export { ForwardRef as ReactComponent };